import { useQuery } from '@cbgms/base/http/use-query'
import { DispatchReturnValue } from '@cbgms/base/redux/async-action'
import { AnyAction } from 'redux'
import { useDispatch } from 'react-redux'
import { IShop } from '@cbgms/api'
import { getCurrentShop } from 'app/shops/state/actions'

const CURRENT_SHOP_QUERY_KEY = ['CurrentShop'] as const
type AsyncDispatch = <T extends AnyAction>(action: T) => DispatchReturnValue<T>

/**
 * Shared hook for fetching the current shop with deduplication.
 *
 * This prevents duplicate GET /modules/shop calls when multiple components
 * or hooks call getCurrentShop simultaneously (e.g. bank holidays and onboarding).
 *
 * The current shop is resolved server-side from the auth token.
 */
export const useCurrentShop = () => {
  const dispatch = useDispatch<AsyncDispatch>()

  return useQuery<IShop, Error>(
    CURRENT_SHOP_QUERY_KEY,
    async (): Promise<IShop> => {
      const result = (await dispatch(getCurrentShop())) as unknown as { Data?: IShop }
      return result.Data!
    },
    {
      staleTime: 5 * 60 * 1000, // 5 minutes — prevents refetch on remount
      cacheTime: 10 * 60 * 1000, // 10 minutes
      refetchOnWindowFocus: false
    }
  )
}
